import React from 'react'

import { graphql, Link } from 'gatsby'

import classes from './index.module.scss'
import PageHead from '../../../components/PageHead'
import EuropeSVG from '../../../static/images/europe.svg'
import { RoamingQueryData } from '../../../types/roaming.types'
import { alphabeticalOrder } from '../../../utils/sorting'

export default function Europe({ data }: RoamingQueryData) {
  return (
    <div className={classes.root}>
      <p
        data-testid={'europe-breadcrumb-wrapper'}
        className={classes.breadcrumbWrapper}
      >
        <Link to="/roaming">Roaming &amp; international</Link>
        <span>{'>'}</span> Europe
      </p>
      <h1 data-testid={'europe-heading'} className={classes.heading}>
        <span>Travelling in the EU?</span>
        <span>
          <img data-testid={'europe-image'} src={EuropeSVG} alt="" />
        </span>
      </h1>
      <h3 data-testid={'europe-subheading'} className={classes.subHeading}>
        Use your SMARTY plan anywhere in the EU
      </h3>
      <p data-testid={'europe-paragraph'} className={classes.altParagraph}>
        Data comes out of your monthly allowance. Calls and Texts are unlimited.
        Please refer to our Fair Use Policy
      </p>
      <p data-testid={'europe-list-paragraph'} className={classes.altParagraph}>
        Check if the country you’re travelling to is in the list:
      </p>
      <div className={classes.container}>
        <ol data-testid={'europe-ordered-list'} className={classes.list}>
          {data.allRoamingPrice.edges.sort(alphabeticalOrder).map(
            ({ node }) =>
              node.country && (
                <li key={node.slug}>
                  <Link to={`/roaming/europe/${node.slug}`}>
                    <img
                      className={classes.flag}
                      src={`/assets/images/flags/${node.iso_country_code.toLowerCase()}.png`}
                      alt=""
                    />
                    {node.display_country}
                  </Link>
                </li>
              )
          )}
        </ol>
        <div data-testid={'europe-card'} className={classes.card}>
          <h2
            data-testid={'europe-card-heading-one'}
            className={classes.cardHeading}
          >
            Before you go
          </h2>
          <h2 data-testid={'europe-card-heading-two'}>
            Phone settings update required
          </h2>
          <p
            data-testid={'europe-card-paragraph'}
            className={classes.paragraph}
          >
            Your SMARTY SIM won’t work abroad unless you make a one-off change
            to your phone settings.
          </p>
          <a data-testid={'europe-card-link'} href="/roaming-setup">
            Set up your phone now
          </a>
        </div>
      </div>
    </div>
  )
}

export const query = graphql`
  query {
    allRoamingPrice(filter: { european_country: { eq: true } }) {
      edges {
        node {
          display_country
          country
          slug
          iso_country_code
        }
      }
    }
  }
`

export const Head = () => <PageHead title="Travelling in the EU" />
